import moment from 'moment-timezone';

function plural(word, num) {
    const forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}

function relativeTimeWithPlural(number, withoutSuffix, key) {
    const format = {
        'ss': 'секунда_секунди_секунд',
        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        'hh': 'година_години_годин',
        'dd': 'день_дня_днів',
        'MM': 'місяць_місяця_місяців',
        'yy': 'рік_року_років'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}

let monthsParse = [/^січ/i, /^лют/i, /^бер/i, /^квіт/i, /^трав/i, /^черв/i, /^лип/i, /^серп/i, /^вер/i, /^жовт/i, /^лист/i, /^груд/i];

let uk = moment.defineLocale('uk', {
    months : {
        format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
        standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
    },
    monthsShort : {
        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
        format: 'січ._лют._бер._квіт._трав._черв._лип._серп._вер._жовт._лист._груд.'.split('_'),
        standalone: 'січ._лют._бер._квіт._трав._черв._лип._серп._вер._жовт._лист._груд.'.split('_')
    },
    weekdays : {
        standalone: 'неділя_понеділок_вівторок_середа_четвер_пятниця_субота'.split('_'),
        format: 'неділю_понеділок_вівторок_середу_четвер_пятницю_субота'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:минулу|наступну|цю)? ?\] ?dddd/
    },
    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(січен[ья]|січ\.?|лют[ийого]|лют\.?|березен[ья]|бер\.?|квітен[ья]|квіт\.?|трав[еньня]|трав\.?|черв[еньня]|черв\.?|лип[еньня]|лип\.?|серп[еньня]?|серп\.?|верес[еньня]|вер?\.?|жовт[еньня]|жовт\.?|листопад[а]|лист?\.?|груд[няень]|груд\.?)/i,

    // копия предыдущего
    monthsShortRegex: /^(січен[ья]|січ\.?|лют[ийого]|лют\.?|березен[ья]|бер\.?|квітен[ья]|квіт\.?|трав[еньня]|трав\.?|черв[еньня]|черв\.?|лип[еньня]|лип\.?|серп[еньня]?|серп\.?|верес[еньня]|вер?\.?|жовт[еньня]|жовт\.?|листопад[а]|лист?\.?|груд[няень]|груд\.?)/i,

    // полные названия с падежами
    monthsStrictRegex: /^(січен[ья]|лют[ийого]|березен[ья]|квітен[ья]|трав[еньня]|черв[еньня]|лип[еньня]|серп[еньня]|верес[еньня]|жовт[еньня]|листопад[а]|груд[няень])/i,

    // Выражение, которое соотвествует только сокращённым формам
    monthsShortStrictRegex: /^(січ\.|лют?\.|бер\.|квіт\.|трав\.|черв\.|лип\.|серп\.|вер\.|жовт\.|лист\.|груд\.)/i,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сьогодні в] LT',
        nextDay: '[Завтра в] LT',
        lastDay: '[Вчора в] LT',
        nextWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[Наступного] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[Наступний] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[Наступну] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[В] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        lastWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В минуле] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В минулий] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В минулу] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[В] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'через %s',
        past : '%s назад',
        s : 'кількі секунд',
        ss : relativeTimeWithPlural,
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'година',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'місяць',
        MM : relativeTimeWithPlural,
        y : 'рік',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночі|ранку|дня|вечора/i,
    isPM : function (input) {
        return /^(дня|вечора)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночі';
        } else if (hour < 12) {
            return 'ранку';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечора';
        }
    },
    ordinalParse: /\d{1,2}-(й|го|а)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-а';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});
